(function($) {
	/**
	 * Object JSON
	 */
	window.searchType = '';
	window.products = [];
	window.jsonObj = {};
	window.sales = {
		data: [],
		discount_type: '',
		discount: 0,
		sub_total: 0,
		total: 0,
		payment: 0,
		change: 0,
		payment_type: 0
	};
	window.entradas = {
		data: []
	};
	window.salidas = {
		data: []
	};
	/**
	 * Ajax Query
	 */
	window.ajaxQuery = async function(url, type = 'GET', data = {}) {
		var result = await $.ajax({
			url: url,
			type: type,
			data: data,
		});
		return result;
	}

	/**
	 * Function to show waitMe
	 */
	window.showWaiteMe = function(element, effect, text) {
		$(element).waitMe({
			effect: effect,
			text: text
		});
	}

	/**
	 * Function to show waitMe
	 */
	window.hideWaitMe = function(element) {
		$(element).waitMe('hide');
	}

	/**
	 * Create localStorage variable
	 */
	window.createLocalStorageVariable = function (variable, value, duration = 24) {
		const now = new Date();
		const time = now.getTime();
		const hours = 60 * 60 * duration;
		const expireTime = (1000 * hours) + time;
		now.setTime(expireTime);
		if (!localStorage.getItem(variable)) {
			localStorage.setItem(variable, JSON.stringify({
				value: value,
				expire: now.getTime(),
			}));
		}
	}
	/**
	 * Update localStorage variable
	 */
	window.updateLocalStorageVariable = function(variable, value, expire) {
		if (localStorage.getItem(variable)) {
			localStorage.setItem(variable, JSON.stringify({
				value: value,
				expire: expire,
			}));
		}
	}

	/**
	 * Get localStorage variable
	 */
	window.getLocalStorageVariable = function(vairable) {
		const itemJson = localStorage.getItem(vairable);
		if (itemJson) {
			const item = JSON.parse(itemJson);
			return item;
		}
		return null;
	}

	/**
	 * Delete localStorage variable
	 */
	window.deleteLocalStorageVariable = function(variables) {
		const timestamp = new Date().getTime();
		variables.forEach(function(variable) {
			const itemLocalStorage = localStorage.getItem(variable);
			if (itemLocalStorage) {
				const data = JSON.parse(itemLocalStorage);
				if (timestamp >= data.expire) {
					localStorage.removeItem(variable);
				}
			}
		});
	}

	/**
	 * Force delete localStorage variable
	 */
	window.forceDeleteLocalStorageVariable = function(variables) {
		variables.forEach(function(variable) {
			const itemLocalStorage = localStorage.getItem(variable);
			if (itemLocalStorage) {
				localStorage.removeItem(variable);
			}
		});
	}
	/**
	 * Create/Update LocalStorageVariable
	 */
	window.persistState = function(type) {
		var stored = window.getLocalStorageVariable(type);
		if (!stored) {
			window.createLocalStorageVariable(type, window[type]);
			return;
		}
		window.updateLocalStorageVariable(type, window[type], stored.expire);
	}
	/**
	 * Pad date
	 */
	window.pad = function(n) {
		return String(n).padStart(2, '0');
	}
	/**
	 * Date FormatedToLocal
	 */
	window.formatedToLocal = function(dateString) {
		var dateObj = new Date(dateString);
		return `${pad(dateObj.getDate())}/${pad(dateObj.getMonth() + 1)}/${dateObj.getFullYear()} ${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;
	}
	// Antes de parsear: convierte UTF-8 a "bytes como caracteres"
	window.toByteString = function(str) {
		return unescape(encodeURIComponent(str));
	}

	// Después de extraer un string del resultado: vuelve a UTF-8 real
	window.fromByteString = function(str) {
		return decodeURIComponent(escape(str));
	}
	/**
	 * Unserlialize PHP
	 */
	window.unserializePHP = function(data) {
		// Helper function to extract tokenized values from PHP serialization
		let offset = 0;

		function parse() {
			const type = data[offset];
			offset += 2; // Skip type and colon

			if (type === 'a') { // Array / Object
				const lengthMatch = data.substring(offset).match(/^(\d+):\{/);
				const count = parseInt(lengthMatch[1], 10);
				offset += lengthMatch[0].length;
				
				const result = {};
				for (let i = 0; i < count; i++) {
					const key = parse();
					const value = parse();
					result[key] = value;
				}
				offset += 1; // Skip closing brace '}'
				return result;
			} 
			else if (type === 's') { // String
				const lengthMatch = data.substring(offset).match(/^(\d+):"/);
				const length = parseInt(lengthMatch[1], 10);
				offset += lengthMatch[0].length;
				const val = data.substring(offset, offset + length);
				offset += length + 2; // Skip string content and closing `";`
				return val;
			} 
			else if (type === 'i') { // Integer
				const valMatch = data.substring(offset).match(/^(-?\d+);/);
				const val = parseInt(valMatch[1], 10);
				offset += valMatch[0].length;
				return val;
			}
		}
		return parse();
	}
	/**
	 * Format price
	 */
	window.formatMoneyMX = function(amount, decimals = 2, decPoint = '.', thousandsSep = ',') {
		let number = parseFloat(amount);
		if (isNaN(number) || !isFinite(number)) return '0.00';
		let fixedNum = number.toFixed(decimals);
		let parts = fixedNum.split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
		return '$' + parts.join(decPoint);
	}

	/**
	 * Get all products
	 */
	window.getAllProducts = async function(url) {
		window.showWaiteMe('body');
		window.products = await window.ajaxQuery(url);
		window.hideWaitMe('body');
	}

	/**
	 * Show Swal
	 */
	window.showSwal = function(options, onConfirm, onCancel) {
		Swal.fire(options).then(function(result) {
			if(result.isConfirmed) {
				if(typeof onConfirm === 'function') {
					onConfirm(result);
				}
			}
			else if (result.isDismissed) {
				if(typeof onCancel === 'function') {
					onCancel(result);
				}
			}
		});
	}

	/**
	 * Scroll to element
	 */
	window.scrollToElement = function(selector, speed = 600) {
		const top = $(selector).offset().top - 72;
		$('html, body').stop().animate({
			scrollTop: top
		}, speed);
	}
})(jQuery);